/**
 * Reseñas REALES de la ficha de Google de SmartPOS (Smartpos Development SL).
 *
 * Se escriben aquí a mano, en español, para que la web NO consulte ninguna API
 * de pago en ninguna visita. Cuando haya que añadir, quitar o cambiar una
 * reseña, edita únicamente este archivo.
 *
 * Cada reseña lleva sus traducciones guardadas (EN / CA / FR), así se muestran
 * al instante al cambiar de idioma, sin esperas y sin gastar nada. Si añades una
 * reseña nueva sin traducciones, la web la muestra en español y la traduce sola
 * en segundo plano; para que sea instantánea, copia el texto a cada idioma en
 * "translations".
 *
 * Las fotos (profile_photo) son URLs públicas, fijas, del avatar de cada autor
 * en Google: se guardan aquí y no se consulta nada al visitante.
 */
export const GOOGLE_REVIEWS = {
  // Nota media y número de reseñas que se muestran en la barra de confianza
  // y en los datos estructurados de Google. Debe coincidir SIEMPRE con el
  // número de reseñas de la lista de abajo: declarar más de las que se ven
  // invalida los datos estructurados para Google.
  rating: 5,
  user_ratings_total: 3,

  // Enlace "ver todas las reseñas" → ficha real en Google.
  url: 'https://maps.google.com/?cid=9315351561216323286',

  // Reseñas que se muestran en la web (el orden de esta lista es el orden en pantalla).
  reviews: [
    {
      author: 'Specterous',
      rating: 5,
      profile_photo: 'https://lh3.googleusercontent.com/a-/ALV-UjVivDn0sdfSILrY6m41wXuJ0-88Ed8uQXtVIqnH-M3lbiXrRCvI=s128-c0x00000000-cc-rp-mo-ba3',
      relative_time: 'Hace 5 meses',
      text: `Brutal cuánto me ayudaron a arrancar, la gestiones el día de antes y todas las ayudas.

Sin duda, gracias a ellos todo me fue más fácil.`,
      translations: {
        EN: `They helped me get started an incredible amount — they handled the paperwork the day before, plus all the support.

No doubt about it, thanks to them everything was easier.`,
        CA: `Increïble com em van ajudar a arrencar, es van encarregar de les gestions el dia abans i de tot el suport.

Sens dubte, gràcies a ells tot em va ser més fàcil.`,
        FR: `Incroyable, ils m'ont énormément aidé à démarrer : ils se sont occupés des démarches la veille et de tout le reste.

Sans aucun doute, grâce à eux tout a été plus facile.`,
      },
    },
    {
      author: 'ivan fernandez rodrigo',
      rating: 5,
      profile_photo: 'https://lh3.googleusercontent.com/a/ACg8ocL082-ILxQHRtCidv1LK7T8fxBWbSESVuO2E9lySmS-BhdEFw=s128-c0x00000000-cc-rp-mo',
      relative_time: 'Hace 5 meses',
      text: 'Muy buena empresa, a cualquier problema buscan la mejor solucion y en poco tiempo todo correcto',
      translations: {
        EN: 'A very good company: whatever the problem, they look for the best solution and everything is sorted out quickly.',
        CA: 'Molt bona empresa, davant qualsevol problema busquen la millor solució i en poc temps tot correcte.',
        FR: "Très bonne entreprise : quel que soit le problème, ils cherchent la meilleure solution et tout est réglé rapidement.",
      },
    },
    {
      author: 'Chocofiro CHOCOFIRO S.L.',
      rating: 5,
      profile_photo: 'https://lh3.googleusercontent.com/a-/ALV-UjWBZ_k6cYqj-bs3WDEtL5_TeS8mN4EqNNSUApFaHLL_kMtKy-xi=s128-c0x00000000-cc-rp-mo',
      relative_time: 'Hace 7 meses',
      text: `En GrupFIRO estamos muy contentos con Smartpos. Desde que trabajamos con ellos, el día a día en los restaurantes es mucho más ágil y organizado. El sistema es fácil de usar, rápido y nos facilita mucho la gestión, especialmente en horas punta.

Además, siempre que necesitamos ayuda, el equipo siempre ha respondido de manera rápida y con un trato muy cercano, algo que valoramos muchísimo.

Sin duda, una herramienta que nos aporta tranquilidad y nos permite centrarnos en lo más importante, que son nuestros clientes.`,
      translations: {
        EN: `At GrupFIRO we are very happy with Smartpos. Since we started working with them, day-to-day life in our restaurants is much more agile and organised. The system is easy to use, fast, and it makes management much easier for us, especially at peak times.

What's more, whenever we need help, the team has always responded quickly and in a very friendly way, which we value enormously.

Without a doubt, a tool that gives us peace of mind and lets us focus on what matters most: our customers.`,
        CA: `A GrupFIRO estem molt contents amb Smartpos. Des que treballem amb ells, el dia a dia als restaurants és molt més àgil i organitzat. El sistema és fàcil d'usar, ràpid i ens facilita molt la gestió, especialment en hores punta.

A més, sempre que necessitem ajuda, l'equip sempre ha respost de manera ràpida i amb un tracte molt proper, cosa que valorem moltíssim.

Sens dubte, una eina que ens aporta tranquil·litat i ens permet centrar-nos en el més important, que són els nostres clients.`,
        FR: `Chez GrupFIRO, nous sommes très satisfaits de Smartpos. Depuis que nous travaillons avec eux, le quotidien dans nos restaurants est bien plus fluide et organisé. Le système est facile à utiliser, rapide, et il nous facilite beaucoup la gestion, surtout aux heures de pointe.

De plus, chaque fois que nous avons besoin d'aide, l'équipe a toujours répondu rapidement et avec un contact très proche, ce que nous apprécions énormément.

Sans aucun doute, un outil qui nous apporte de la sérénité et nous permet de nous concentrer sur l'essentiel : nos clients.`,
      },
    },
  ],
};